import { EditageConfig } from 'config/onelogin.config';
import { getEnv } from 'utils';

export default function getRedirectUrlAfterLogin(redirectPath = '/my-creations') {
  return `${EditageConfig.sso.mainDomain}/login?continue=${encodeURIComponent(getEnv('MTG_URL_APP') + redirectPath)}`;
}
